import { type GA4PageNameType } from '@/ga4types'
import analytics from '@/shared-utils/analytics'

import { GA4TripTypeMapper } from '../BundleAndSave/utils'
import type { HOTEL_FORM_STATE_TYPE } from './types'

export default function fireHotelSubmitEvent(
  initialState: HOTEL_FORM_STATE_TYPE,
  submittedState: HOTEL_FORM_STATE_TYPE,
  pageName: GA4PageNameType,
  itemName?: string,
) {
  const isBundled = submittedState.tripType.includes(':')
  analytics.fireGA4Event({
    event: 'search',
    attributes: {
      date_change:
        initialState.startDate !== submittedState.startDate || initialState.endDate !== submittedState.endDate
          ? 'y'
          : 'n',
      trip_start_city_change: initialState.startLocation !== submittedState.startLocation ? 'y' : 'n',
      trip_end_city_change: initialState.endLocation !== submittedState.endLocation ? 'y' : 'n',
      quantity_change:
        initialState.travelers.adults !== submittedState.travelers.adults ||
        initialState.travelers.children !== submittedState.travelers.children ||
        initialState.travelers.rooms !== submittedState.travelers.rooms
          ? 'y'
          : 'n',
      page_name: pageName,
      product_name: 'hotel',
      type: submittedState?.endLocation?.filters?.length ? 'ai_query' : undefined,
      ...(itemName ? { item_name: itemName } : {}),
      bundle_flag: isBundled ? 'y' : 'n',
      ...(isBundled ? { bundle_type: GA4TripTypeMapper(submittedState.tripType) } : {}),
    },
  })
}

export function fireBundleAndSaveEvent(tripType: string) {
  const mappedTripType = GA4TripTypeMapper(tripType)
  analytics.fireGA4Event({
    event: 'select_promotion',
    attributes: {
      type: 'add_on',
      product_name: 'hotel',
      bundle_flag: 'y',
      bundle_type: mappedTripType,
    },
  })
}

export function fireMultiHotelRadioClick(pageName: 'homepage' | 'landing') {
  analytics.fireGA4Event({
    event: 'select_promotion',
    attributes: {
      type: 'package',
      page_name: pageName,
      product_name: 'hotel',
      bundle_flag: 'y',
      bundle_type: 'hh',
    },
  })
}
